import type { FC, ReactElement } from 'react';

import { useHideCurrency } from '../../../store/compositeSelectors/useHideCurrency';
import { useGameStateSlice } from '../../../store/slices/game/selectors';
import type { InputProps } from '../baseInput/BaseInput';

import { CurrencyInput } from './index';

export interface CurrencyInputConnectedProps extends Omit<InputProps, 'prefix'> {
  initialValue?: string;
  containerClass?: string;
  errorMsg?: string;
}

export const CurrencyInputConnected: FC<CurrencyInputConnectedProps> = ({ initialValue, ...rest }): ReactElement => {
  const currency = useGameStateSlice.getCurrency();
  const currencyInfo = useGameStateSlice.getCurrencyInfo();

  const hideCurrency = useHideCurrency();

  return (
    <CurrencyInput
      currency={hideCurrency ? '' : currency!}
      currencyInfo={currencyInfo || undefined}
      initialValue={initialValue}
      {...rest}
    />
  );
};
